"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLDialogElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLDialogElementImpl
};
